<template>
  <v-row>
    <v-col
      cols="12"
    >
      <v-card
        :loading="loading"
      >
        <v-card-title
          class="text-subtitle-2"
        >
          {{ $t('auth.change_email') }}
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-form
            ref="form"
            @submit.prevent="changeEmail()"
          >
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  prepend-icon="email"
                  name="email"
                  :label="$t('common.email_address')"
                  type="email"
                  :rules="rules.email"
                  validate-on-blur
                  :error-messages="errors.email"
                  v-model="email"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  prepend-icon="email"
                  name="email_confirmation"
                  :label="$t('common.email_confirmation')"
                  type="email"
                  v-model="email_confirmation"
                  @input="$refs.form.validate()"
                />
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer />
              <v-btn
                type="submit"
                color="primary"
              >
                {{ $t('auth.change_email_request') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import url from '../../../utils/url';
import { ruleRequired, ruleEmail, ruleConfirmed } from '../../../utils/rules';

export default {
  name: 'ChangeEmail',
  props: {
    accountName: {
      type: String,
    },
    userId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      email: '',
      email_confirmation: '',
      errors: {
        email: [],
        email_confirmation: [],
      },
    };
  },
  computed: {
    ...mapGetters(['user']),
    profileUrl() {
      return url`/api/v1/accounts/${this.accountName}/users/${this.userId}`;
    },
    rules() {
      return {
        email: [
          ruleRequired(this.$t('validation.required', { attribute: this.$t('common.email_address') })),
          ruleEmail(this.$t('validation.email', { attribute: this.$t('common.email_address') })),
          ruleConfirmed(() => this.email_confirmation, this.$t('validation.confirmed', { attribute: this.$t('common.email_address') })),
        ],
      };
    },
  },
  methods: {
    ...mapActions(['success', 'error']),
    resetErrors() {
      Object.keys(this.errors).forEach(field => {
        this.errors[field] = [];
      });
    },
    async changeEmail() {
      if (!this.$refs.form.validate()) return;

      try {
        this.loading = true;
        this.resetErrors();
        const { email, email_confirmation } = this;
        const { status } = await this.http.post(this.profileUrl, { email, email_confirmation });

        if (status === 200) {
          this.success(this.$t('auth.change_email_success'));
          this.email = '';
          this.email_confirmation = '';
          return;
        }

        throw new Error('Error Changing Email!');
      } catch (e) {
        if (e.response && e.response.data && e.response.data.errors) {
          const { errors = {} } = e.response.data;
          Object.keys(this.errors).forEach(field => {
            this.errors[field] = errors[field] || [];
          });
          return;
        }
        this.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
